import React from 'react';
import BaseIcon, { IconProps } from './Base.icon';

const CalendarIcon = ({ width, height }: IconProps) => {
  return (
    <BaseIcon width={width} height={height} viewBox="0 0 16 16">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.7333 3.2C12.3733 3.2 12.8 2.66667 12.8 2.13333V1.06667C12.8 0.426667 12.3733 0 11.7333 0C11.0933 0 10.6667 0.426667 10.6667 1.06667V2.13333C10.6667 2.66667 11.0933 3.2 11.7333 3.2ZM14.9333 1.06667H13.8667V2.13333C13.8667 3.30667 12.9067 4.26667 11.7333 4.26667C10.56 4.26667 9.6 3.30667 9.6 2.13333V1.06667H6.4V2.13333C6.4 3.30667 5.44 4.26667 4.26667 4.26667C3.09333 4.26667 2.13333 3.30667 2.13333 2.13333V1.06667H1.06667C0.426667 1.06667 0 1.6 0 2.13333V14.9333C0 15.5733 0.426667 16 1.06667 16H14.9333C15.5733 16 16 15.5733 16 14.9333V2.13333C16 1.49333 15.4667 1.06667 14.9333 1.06667ZM5.33333 13.8667H2.13333V10.6667H5.33333V13.8667ZM5.33333 9.6H2.13333V6.4H5.33333V9.6ZM9.6 13.8667H6.4V10.6667H9.6V13.8667ZM9.6 9.6H6.4V6.4H9.6V9.6ZM13.8667 13.8667H10.6667V10.6667H13.8667V13.8667ZM13.8667 9.6H10.6667V6.4H13.8667V9.6ZM4.26667 3.2C4.90667 3.2 5.33333 2.66667 5.33333 2.13333V1.06667C5.33333 0.426667 4.90667 0 4.26667 0C3.62667 0 3.2 0.426667 3.2 1.06667V2.13333C3.2 2.66667 3.62667 3.2 4.26667 3.2Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
};

export default CalendarIcon;
